var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-automation-list" },
    [
      _c(
        "h3",
        { staticClass: "title" },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("automation.automations")) +
              "\n        "
          ),
          _c("a-badge", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content: _vm.hasHiddenAutomations
                    ? _vm.$t("automation.totalAutomationsWithHidden", {
                        total: _vm.totalAutomationCount,
                        visible: _vm.visibleAutomationCount,
                      })
                    : _vm.$t("automation.totalAutomations", {
                        count: _vm.totalAutomationCount,
                      }),
                },
                expression:
                  "{ content: hasHiddenAutomations \n                ? $t('automation.totalAutomationsWithHidden', { total: totalAutomationCount, visible: visibleAutomationCount })\n                : $t('automation.totalAutomations', { count: totalAutomationCount }) }",
              },
            ],
            attrs: {
              count: _vm.totalAutomationCount,
              "number-style": {
                backgroundColor: _vm.hasHiddenAutomations
                  ? "#faad14"
                  : "#52c41a",
              },
              title: _vm.hasHiddenAutomations
                ? _vm.$t("automation.totalAutomationsWithHidden", {
                    total: _vm.totalAutomationCount,
                    visible: _vm.visibleAutomationCount,
                  })
                : _vm.$t("automation.totalAutomations", {
                    count: _vm.totalAutomationCount,
                  }),
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "operated-task-count" }, [
            _vm._v(
              _vm._s(_vm.$t("automation.operatedTask")) +
                ": " +
                _vm._s(_vm.totalAutomationUsage)
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasAutomationInClipboard
        ? _c("div", { staticClass: "paste-info-message" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("content_paste"),
            ]),
            _vm._v(" "),
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("automation.pasteInfoMessage")),
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "table-wrapper" }, [
        _c("div", { staticClass: "toolbar" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c("a-input-search", {
                staticClass: "search-input",
                staticStyle: { width: "300px", margin: "unset !important" },
                attrs: {
                  placeholder: _vm.$t("message.search"),
                  autoComplete: "off",
                },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
              _vm._v(" "),
              _c("CommonFilterTool", {
                attrs: {
                  "keep-state-on-query-params": false,
                  "filter-meta": _vm.filterMetas,
                  "label-formatter": _vm.filterLabelFormatter,
                },
                on: { addFilter: _vm.addFilter },
                model: {
                  value: _vm.breakdownFilter,
                  callback: function ($$v) {
                    _vm.breakdownFilter = $$v
                  },
                  expression: "breakdownFilter",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["automation.create"] } },
                [
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "category-btn",
                      on: {
                        click: function ($event) {
                          _vm.showCreateCategoryModal = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("category"),
                      ]),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("automation.createCategory")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-dropdown",
                { attrs: { trigger: ["click"] } },
                [
                  _c(
                    "PermissionController",
                    { attrs: { permissions: ["automation.create"] } },
                    [
                      _c("SupsisButton", { attrs: { primary: "" } }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("message.newAutomation")) +
                            "\n                            "
                        ),
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            staticStyle: {
                              "font-size": "16px",
                              "margin-left": "5px",
                            },
                          },
                          [_vm._v("arrow_drop_down")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-menu",
                    {
                      staticClass: "automation-dropdown-menu",
                      attrs: { slot: "overlay" },
                      slot: "overlay",
                    },
                    [
                      !_vm.module
                        ? _c(
                            "a-menu-item",
                            {
                              attrs: { disabled: _vm.loading },
                              on: {
                                click: function ($event) {
                                  return _vm.$feature.beforeCreateTimerAutomation(
                                    _vm.createEmptyTimerAutomation
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("timer"),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("automation.createTimerAutomation")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$feature.beforeCreateEventBasedAutomation(
                                _vm.showEventAutomationModal
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("event"),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("automation.createEventBasedAutomation")
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.module
                        ? _c(
                            "a-menu-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.$feature.beforeCreateWebhookAutomation(
                                    _vm.showWebhookAutomationModal
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("webhook"),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("automation.createWebhookAutomation")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.selectionMode
          ? _c(
              "div",
              { staticClass: "selection-toolbar" },
              [
                _c(
                  "div",
                  { staticClass: "selection-info" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("automation.selectedAutomations", {
                            count: _vm.checkboxOption.selectedRowKeys.length,
                          })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: "" },
                        on: { click: _vm.exitSelectionMode },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "PermissionController",
                  { attrs: { permissions: ["automation.delete"] } },
                  [
                    _vm.checkboxOption.selectedRowKeys.length > 0
                      ? _c(
                          "SupsisButton",
                          {
                            attrs: { danger: "" },
                            on: { click: _vm.deleteMultiAutomations },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("delete"),
                            ]),
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("automation.deleteAutomations", {
                                    count:
                                      _vm.checkboxOption.selectedRowKeys.length,
                                  })
                                ) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "categories-container" },
          _vm._l(_vm.categorizedAutomations, function (category) {
            return _c(
              "div",
              {
                key: category.name,
                staticClass: "category-section",
                class: { "drag-over": _vm.dragOverCategory === category.name },
                on: {
                  drop: function ($event) {
                    return _vm.onDrop($event, category.name)
                  },
                  dragover: function ($event) {
                    return _vm.allowDrop($event, category.name)
                  },
                  dragleave: _vm.onDragLeave,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "category-header",
                    on: {
                      click: function ($event) {
                        return _vm.toggleCategory(category.name)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "category-info" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            staticClass: "collapse-toggle",
                            attrs: { ghost: "", small: "" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleCategory(category.name)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.categoryExpandStates[category.name] !==
                                      false
                                      ? "expand_less"
                                      : "expand_more"
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        category.icon
                          ? _c(
                              "i",
                              { staticClass: "material-icons category-icon" },
                              [_vm._v(_vm._s(category.icon))]
                            )
                          : _c(
                              "i",
                              { staticClass: "material-icons category-icon" },
                              [_vm._v("folder")]
                            ),
                        _vm._v(" "),
                        _c("span", { staticClass: "category-name" }, [
                          _vm._v(
                            _vm._s(
                              category.name === _vm.GENERAL_CATEGORY
                                ? _vm.$t("automation.generalCategory")
                                : category.name
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "automation-count" }, [
                          _vm._v(
                            "(" + _vm._s(category.automations.length) + ")"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "category-actions" },
                      [
                        category.name !== _vm.GENERAL_CATEGORY
                          ? _c("SupsisButton", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.$t("automation.editCategory"),
                                  },
                                  expression:
                                    "{ content: $t('automation.editCategory') }",
                                },
                              ],
                              attrs: { ghost: "", icon: "edit", small: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.editCategory(category)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        category.name !== _vm.GENERAL_CATEGORY
                          ? _c("SupsisButton", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.$t(
                                      "automation.deleteCategory"
                                    ),
                                  },
                                  expression:
                                    "{ content: $t('automation.deleteCategory') }",
                                },
                              ],
                              attrs: {
                                ghost: "",
                                icon: "delete",
                                small: "",
                                danger: "",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteCategory(category.name)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        category.automations.length > 0
                          ? _c(
                              "a-popover",
                              {
                                attrs: {
                                  trigger: "click",
                                  placement: "bottomRight",
                                  overlayClassName: "category-actions-dropdown",
                                  visible:
                                    _vm.categoryDropdownStates[category.name],
                                },
                                on: {
                                  visibleChange: function (visible) {
                                    _vm.$set(
                                      _vm.categoryDropdownStates,
                                      category.name,
                                      visible
                                    )
                                  },
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "dropdown-menu-content" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu-item submenu-item",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("drive_file_move")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "automation.moveAllAutomations"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons submenu-arrow",
                                            },
                                            [_vm._v("chevron_left")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "submenu-content" },
                                            _vm._l(
                                              _vm.availableCategoriesForCategory(
                                                category.name
                                              ),
                                              function (targetCategory) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: targetCategory.name,
                                                    staticClass:
                                                      "submenu-item-content",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.moveAllAutomationsToCategory(
                                                          category.name,
                                                          targetCategory.name
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    targetCategory.icon
                                                      ? _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                targetCategory.icon
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [_vm._v("folder")]
                                                        ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          targetCategory.name ===
                                                            _vm.GENERAL_CATEGORY
                                                            ? _vm.$t(
                                                                "automation.generalCategory"
                                                              )
                                                            : targetCategory.name
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("SupsisButton", {
                                  staticClass: "category-more-actions-btn",
                                  attrs: {
                                    ghost: "",
                                    icon: "more_vert",
                                    small: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.categoryExpandStates[category.name] !== false,
                        expression:
                          "categoryExpandStates[category.name] !== false",
                      },
                    ],
                    staticClass: "automations-grid",
                    class: {
                      collapsed:
                        _vm.categoryExpandStates[category.name] === false,
                    },
                  },
                  [
                    category.automations.length === 0
                      ? _c("div", { staticClass: "empty-category-message" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("drag_handle"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("automation.emptyCategoryMessage"))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(category.automations, function (automation) {
                      return _c(
                        "div",
                        {
                          key: automation._id,
                          staticClass: "automation-card",
                          class: {
                            dragging:
                              _vm.draggedAutomation &&
                              _vm.draggedAutomation._id === automation._id,
                            "selection-mode": _vm.selectionMode,
                            selected:
                              _vm.checkboxOption.selectedRowKeys.includes(
                                automation._id
                              ),
                          },
                          attrs: { draggable: !_vm.selectionMode },
                          on: {
                            dragstart: function ($event) {
                              return _vm.onDragStart($event, automation)
                            },
                            dragend: _vm.onDragEnd,
                            click: function ($event) {
                              _vm.selectionMode
                                ? _vm.toggleAutomationSelection(automation._id)
                                : null
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "automation-card-header" }, [
                            _vm.selectionMode
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "automation-selection",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c("a-checkbox", {
                                      attrs: {
                                        checked:
                                          _vm.checkboxOption.selectedRowKeys.includes(
                                            automation._id
                                          ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.toggleAutomationSelection(
                                            automation._id
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "automation-name",
                                attrs: {
                                  href: _vm.getAutomationHref(automation),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleAutomationClick(
                                      automation,
                                      $event
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(automation.name) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "automation-actions",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c(
                                  "a-popover",
                                  {
                                    attrs: {
                                      trigger: "click",
                                      placement: "bottomRight",
                                      overlayClassName:
                                        "automation-actions-dropdown",
                                      visible:
                                        _vm.dropdownStates[automation._id],
                                    },
                                    on: {
                                      visibleChange: function (visible) {
                                        _vm.$set(
                                          _vm.dropdownStates,
                                          automation._id,
                                          visible
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("template", { slot: "content" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown-menu-content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dropdown-menu-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.duplicateAutomation(
                                                    automation
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("content_copy")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "automation.copyAutomation"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dropdown-menu-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyAutomationAsJSON(
                                                    automation
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("file_copy")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "automation.copyAutomationAsJSON"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          automation.options &&
                                          automation.options.trigger ===
                                            "event" &&
                                          automation.options.event &&
                                          automation.options.event.type ===
                                            "table.record_updated"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openTrackFieldsModal(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("tune")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.configureTrackFields"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          automation.options &&
                                          automation.options.trigger ===
                                            "event" &&
                                          automation.options.event &&
                                          automation.options.event.type ===
                                            "message.matched"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openMessageMatchedConfigModal(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("filter_alt")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.configureMessageFilter"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          automation.options &&
                                          automation.options.trigger ===
                                            "event" &&
                                          _vm.isPreFilterSupported(automation)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openPreFilterModal(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("rule")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.configurePreFilters"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$_.get(_vm.user, "role.isRoot") &&
                                          _vm.isExecutionPrivacySupported(
                                            automation
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openExecutionPrivacyModal(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "admin_panel_settings"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.configureExecutionPrivacy"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$_.get(_vm.user, "role.isRoot")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openPermissionSettingsModal(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("lock")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.permissions.title"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dropdown-menu-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openDescriptionModal(
                                                    automation
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("description")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "automation.editDescription"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.debugMode &&
                                          automation.billable !== false
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.makeFreeTier(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("money_off")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.makeFreeTier"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.debugMode &&
                                          automation.billable === false
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.revertFreeTier(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("attach_money")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.revertFreeTier"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu-item submenu-item",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("drive_file_move")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "automation.changeCategory"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons submenu-arrow",
                                                },
                                                [_vm._v("chevron_left")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "submenu-content",
                                                },
                                                _vm._l(
                                                  _vm.availableCategoriesForAutomation(
                                                    automation
                                                  ),
                                                  function (categoryOption) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: categoryOption.name,
                                                        staticClass:
                                                          "submenu-item-content",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.moveAutomationToCategory(
                                                              automation,
                                                              categoryOption.name
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        categoryOption.icon
                                                          ? _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    categoryOption.icon
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [_vm._v("folder")]
                                                            ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              categoryOption.name ===
                                                                _vm.GENERAL_CATEGORY
                                                                ? _vm.$t(
                                                                    "automation.generalCategory"
                                                                  )
                                                                : categoryOption.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "PermissionController",
                                            {
                                              attrs: {
                                                permissions: [
                                                  "automation.delete",
                                                ],
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.enterSelectionMode(
                                                        automation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("delete")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "automation.deleteAutomation"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("SupsisButton", {
                                      staticClass: "more-actions-btn",
                                      attrs: {
                                        ghost: "",
                                        icon: "more_vert",
                                        small: "",
                                      },
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "automation-trigger" },
                            [
                              automation.options.trigger === "timer"
                                ? [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("timer"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("automation.timerAutomation")
                                        )
                                      ),
                                    ]),
                                  ]
                                : automation.options.trigger === "event"
                                ? [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("event"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("automation.eventAutomation")
                                        ) +
                                          ": " +
                                          _vm._s(automation.options.event.type)
                                      ),
                                    ]),
                                  ]
                                : automation.options.trigger === "webhook"
                                ? [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("webhook"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("automation.webhook"))
                                      ),
                                    ]),
                                  ]
                                : automation.options.trigger === "button"
                                ? [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("smart_button"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("automation.buttonAutomation")
                                        )
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("settings"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(automation.options.trigger)
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          automation.description
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        content: automation.description,
                                      },
                                      expression:
                                        "{ content: automation.description }",
                                    },
                                  ],
                                  staticClass: "automation-description",
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("description"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(automation.description)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          automation.billable === false
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        content: _vm.$t(
                                          "automation.freeTierTooltip"
                                        ),
                                      },
                                      expression:
                                        "{ content: $t('automation.freeTierTooltip') }",
                                    },
                                  ],
                                  staticClass: "free-tier-badge",
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("star"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("automation.freeTierBadge"))
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "automation-meta" }, [
                            _c("div", { staticClass: "meta-left" }, [
                              automation.createdBy
                                ? _c(
                                    "div",
                                    { staticClass: "created-by" },
                                    [
                                      _c("Avatar", {
                                        attrs: {
                                          size: 20,
                                          src: _vm.users[
                                            automation.createdBy._id
                                          ]
                                            ? _vm.users[
                                                automation.createdBy._id
                                              ].gravatar
                                            : null,
                                          username: _vm.users[
                                            automation.createdBy._id
                                          ]
                                            ? _vm.users[
                                                automation.createdBy._id
                                              ].name
                                            : _vm.$t("automation.system"),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.users[automation.createdBy._id]
                                              ? _vm.users[
                                                  automation.createdBy._id
                                                ].name
                                              : _vm.$t("automation.system")
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "created-date" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm
                                        .$moment(automation.createdAt)
                                        .format("DD.MM.YYYY")
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "meta-right" },
                              [
                                _c(
                                  "md-switch",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          content: automation.published
                                            ? _vm.$t(
                                                "automation.publishAutomation"
                                              )
                                            : _vm.$t(
                                                "automation.unpublishAutomation"
                                              ),
                                        },
                                        expression:
                                          "{ content: automation.published ? $t('automation.publishAutomation') : $t('automation.unpublishAutomation') }",
                                      },
                                    ],
                                    key: automation._id,
                                    staticClass: "md-primary publish-switch",
                                    attrs: {
                                      id: automation._id,
                                      value: !automation.published,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.togglePublishState(
                                          automation
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "switch-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            automation.published
                                              ? _vm.$t(
                                                  "automation.publishAutomation"
                                                )
                                              : _vm.$t(
                                                  "automation.unpublishAutomation"
                                                )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.showCreateCategoryModal || _vm.showEditCategoryModal
        ? _c(
            "Modal2",
            {
              attrs: {
                showFooter: false,
                title: _vm.editingCategory
                  ? _vm.$t("automation.editCategory")
                  : _vm.$t("automation.createCategory"),
              },
              on: { cancel: _vm.closeCategoryModal },
            },
            [
              _c("div", { staticClass: "automation-category-form" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("automation.categoryName"))),
                    ]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t(
                          "automation.categoryNamePlaceholder"
                        ),
                      },
                      model: {
                        value: _vm.categoryForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.categoryForm, "name", $$v)
                        },
                        expression: "categoryForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("modules.icon")))]),
                    _vm._v(" "),
                    _c("MaterialIconPicker", {
                      model: {
                        value: _vm.categoryForm.icon,
                        callback: function ($$v) {
                          _vm.$set(_vm.categoryForm, "icon", $$v)
                        },
                        expression: "categoryForm.icon",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-actions d-flex gap-5 flex-end" },
                  [
                    _c(
                      "SupsisButton",
                      { on: { click: _vm.closeCategoryModal } },
                      [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.saveCategory },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.editingCategory
                                ? _vm.$t("message.update")
                                : _vm.$t("settings.create")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eventAutomationModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.createAnEventAutomation"),
                "show-title": "",
                "show-footer": false,
                "class-name": "create-event-automation-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.eventAutomationModalVisible = false
                },
              },
            },
            [
              _c("EventSelector", {
                attrs: { "default-module": _vm.module },
                on: { save: _vm.createEmptyEventAutomation },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.webhookAutomationFormModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.chatWebhookAutomation"),
                "show-title": "",
                "show-footer": false,
                "class-name": "event-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.webhookAutomationFormModalVisible = false
                },
              },
            },
            [
              _c("WebhookAutomationForm", {
                on: { save: _vm.createWebhookAutomation },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tableSelectionModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.tableSelection"),
                "show-title": "",
                "show-footer": false,
                "class-name": "table-selection-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.tableSelectionModalVisible = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "table-selection-form" },
                [
                  _vm.$event
                    ? _c(
                        "div",
                        { staticClass: "event-description" },
                        [
                          _vm.$event.event === "table.record_created"
                            ? [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "automation.whichTableAutomationAddRecords"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            : _vm.$event.event === "table.record_updated"
                            ? [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "automation.whichTableAutomationUpdateRecords"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            : _vm.$event.event === "table.record_deleted"
                            ? [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "automation.whichTableAutomationDeletedRecords"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            : _vm.$event.event ===
                              "table.record_automation_button_clicked"
                            ? [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "automation.whichTableAutomationClickRecords"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("CustomPicker", {
                    attrs: {
                      items: _vm.tables,
                      idKey: "_id",
                      labelKey: "name",
                      title: _vm.$t("automation.selectTable"),
                      icon: "table_chart",
                    },
                    model: {
                      value: _vm.selectedTableId,
                      callback: function ($$v) {
                        _vm.selectedTableId = $$v
                      },
                      expression: "selectedTableId",
                    },
                  }),
                  _vm._v(" "),
                  _vm.selectedTableId &&
                  _vm.$event &&
                  _vm.$event.event === "table.record_updated"
                    ? _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("automation.trackFieldsLabel"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                mode: "multiple",
                                loading: _vm.tableFieldLoading,
                                placeholder: _vm.$t(
                                  "automation.trackFieldsSelectPlaceholder"
                                ),
                              },
                              model: {
                                value: _vm.selectedFieldIds,
                                callback: function ($$v) {
                                  _vm.selectedFieldIds = $$v
                                },
                                expression: "selectedFieldIds",
                              },
                            },
                            _vm._l(_vm.tableFields, function (f) {
                              return _c(
                                "a-select-option",
                                { key: f._id, attrs: { value: f._id } },
                                [_vm._v(_vm._s(f.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "PermissionController",
                    {
                      attrs: {
                        permissions: ["automation.create", "table.create"],
                        controller: "every",
                      },
                    },
                    [
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.createEventAutomationWithTable },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("tables.create")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.trackFieldModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.trackFieldsLabel"),
                "show-title": "",
                "show-footer": false,
                "class-name": "table-selection-modal",
              },
              on: { cancel: _vm.closeTrackFieldsModal },
            },
            [
              _c("div", { staticClass: "table-selection-form" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("automation.trackFieldsLabel"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          mode: "multiple",
                          loading: _vm.trackFieldLoading,
                          placeholder: _vm.$t(
                            "automation.selectFieldPlaceholder"
                          ),
                        },
                        model: {
                          value: _vm.trackSelectedFieldIds,
                          callback: function ($$v) {
                            _vm.trackSelectedFieldIds = $$v
                          },
                          expression: "trackSelectedFieldIds",
                        },
                      },
                      _vm._l(_vm.trackTableFields, function (f) {
                        return _c(
                          "a-select-option",
                          { key: f._id, attrs: { value: f._id } },
                          [_vm._v(_vm._s(f.name))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-actions d-flex gap-5 flex-end" },
                  [
                    _c(
                      "SupsisButton",
                      { on: { click: _vm.closeTrackFieldsModal } },
                      [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.saveTrackFieldsForAutomation },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.save")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("MessageMatchedConfig", {
        attrs: {
          visible: _vm.messageMatchedConfigModalVisible,
          "show-footer": false,
          "ok-text": _vm.$t("message.save"),
          "cancel-text": _vm.$t("message.cancelText"),
        },
        on: {
          save: _vm.saveMessageMatchedConfig,
          cancel: _vm.closeMessageMatchedConfigModal,
        },
        model: {
          value: _vm.messageMatchedConfig,
          callback: function ($$v) {
            _vm.messageMatchedConfig = $$v
          },
          expression: "messageMatchedConfig",
        },
      }),
      _vm._v(" "),
      _vm.preFilterModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.preFiltersConfiguration"),
                "show-title": "",
                "show-footer": false,
                "class-name": "prefilter-config-modal",
              },
              on: { cancel: _vm.closePreFilterModal },
            },
            [
              _c(
                "div",
                { staticClass: "prefilter-modal-content" },
                [
                  _c("PreFilterConfig", {
                    attrs: { automation: _vm.preFilterAutomation },
                    model: {
                      value: _vm.preFilterConfig,
                      callback: function ($$v) {
                        _vm.preFilterConfig = $$v
                      },
                      expression: "preFilterConfig",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-actions d-flex gap-5 flex-end",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closePreFilterModal } },
                        [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.savePreFilterConfig },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.executionPrivacyModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.executionPrivacyConfiguration"),
                "show-title": "",
                "show-footer": false,
                "class-name": "execution-privacy-config-modal",
              },
              on: { cancel: _vm.closeExecutionPrivacyModal },
            },
            [
              _c(
                "div",
                { staticClass: "execution-privacy-modal-content" },
                [
                  _c("ExecutionPrivacyChanger", {
                    model: {
                      value: _vm.executionPrivacyConfig,
                      callback: function ($$v) {
                        _vm.executionPrivacyConfig = $$v
                      },
                      expression: "executionPrivacyConfig",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-actions d-flex gap-5 flex-end",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closeExecutionPrivacyModal } },
                        [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.saveExecutionPrivacyConfig },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.permissionSettingsModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.permissions.title"),
                "show-title": "",
                "show-footer": false,
                "class-name": "permission-settings-modal",
                width: 1400,
              },
              on: { cancel: _vm.closePermissionSettingsModal },
            },
            [
              _vm.permissionSettingsAutomation
                ? _c("AutomationPermissionSettings", {
                    attrs: { automation: _vm.permissionSettingsAutomation },
                    on: {
                      close: _vm.closePermissionSettingsModal,
                      saved: _vm.onPermissionConfigSaved,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.descriptionModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("automation.editDescription"),
                "show-title": "",
                "show-footer": false,
                "class-name": "description-modal",
              },
              on: { cancel: _vm.closeDescriptionModal },
            },
            [
              _c(
                "div",
                { staticClass: "description-modal-content" },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: _vm.$t("automation.descriptionPlaceholder"),
                      "auto-size": { minRows: 3, maxRows: 8 },
                    },
                    model: {
                      value: _vm.descriptionForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.descriptionForm, "description", $$v)
                      },
                      expression: "descriptionForm.description",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-actions d-flex gap-5 flex-end",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c(
                        "SupsisButton",
                        { on: { click: _vm.closeDescriptionModal } },
                        [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.saveDescription },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }